/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RoomControllerService {
    /**
     * @returns any Array of attributes  with selected fields
     * @throws ApiError
     */
    public static roomControllerGetAllRooms(): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/room',
        });
    }
}
